import React from 'react';
// import { Rating } from "@mui/material";
// import { Slider } from "@/src/HOC/SwiperSlider";
// import { SwiperSlide } from "swiper/react";
import Image from 'next/image';
import { generateNumberBasedOnId } from '@/utils/generateCount';

import StarRating from './StarRating';

// import { useGenericApi } from "@/src/hooks/useGenericApi";
const LeadFormReview = ({ reviewData }: any) => {
  return (
    <>
      {reviewData?.length > 0 && (
        <div className="px-4 space-y-1 mt-2">
          <p className="text-black font-poppins font-semibold text-sm">What students say about colleges</p>
          <div className="overflow-auto">
            {reviewData?.map((review: any) => {
              const rating = generateNumberBasedOnId(review?.id, 3, 5);
              return (
                <div key={review.id}>
                  <div className="p-2 my-1 bg-white border shadow-md rounded-lg h-[6.5rem] flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-x-2">
                        <Image
                          src={review?.banner?.url ?? '/icons/user.png'}
                          alt={review?.name ?? 'user'}
                          width={500}
                          height={500}
                          className="w-9 h-9 rounded-full object-center object-fill"
                        />
                        <div>
                          <p className="text-primary font-bold text-xs lg:text-sm tracking-wide leading-3 line-clamp-1">
                            {review?.name}
                          </p>
                          <StarRating value={rating ?? 4} />
                        </div>
                      </div>
                      <p className="mt-1.5 mb-1 text-black lg:tracking-tight text-xxs lg:text-xs leading-3 line-clamp-2">
                        {review?.testimonial}
                      </p>
                    </div>
                    <small className="text-secondary-gray text-xxs">{review?.college?.college_name}</small>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default LeadFormReview;
